import { useState, useEffect } from "react";
import { Breadcrumb, Button, Badge, Dropdown, Modal } from "react-bootstrap";
import { FaBell, FaTools, FaStar, FaPaperPlane, FaTimes, FaNewspaper } from "react-icons/fa";
import LoadingComponent from "../../widgets/LoadingComponent";
import { getData } from "../../api/ApiRest";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";

const PALETA_COLORES = {
    "A": { background: "#224B6A", badge: "#224B6A" },
    "M": { background: "#198754", badge: "#198754" },
    "N": { background: "#F5C227", badge: "#F5C227" },
    default: { background: "#6c757d", badge: "#6c757d" }
};

function NovedadVisualiza() {
    const [loading, setLoading] = useState(false);
    const [novedades, setNovedades] = useState([]);
    const [filtro, setFiltro] = useState("Todos");
    const [orden, setOrden] = useState("Más reciente");
    const [modalDetalles, setModalDetalles] = useState(false);
    const [novedadSeleccionada, setNovedadSeleccionada] = useState(null);

    useEffect(() => {
        cargarNovedades();
    }, []);

    const cargarNovedades = () => {
        setLoading(true);
        getData('api/Configuracion/Novedad/getNovedades').then(response => {
            setNovedades(response.novedades);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const novedadesFiltradas = novedades.filter(n => {
        if (filtro === "Todos") return true;
        if (filtro === "Actualización") return n.tipo === "A";
        if (filtro === "Mejoras") return n.tipo === "M";
        if (filtro === "Noticias") return n.tipo === "N";
        return true;
    }).sort((a, b) => {
        const fechaA = new Date(a.fecha);
        const fechaB = new Date(b.fecha);
        return orden === "Más reciente" ? fechaB - fechaA : fechaA - fechaB;
    });

    const getIcono = (tipo) => {
        if (tipo === "A") return <FaBell size={22} color="#fff" />;
        if (tipo === "M") return <FaTools size={22} color="#fff" />;
        if (tipo === "N") return <FaNewspaper size={22} color="#fff" />;
        return <FaStar size={22} color="#fff" />;
    };

    const getIconoColor = (tipo) => {
        return PALETA_COLORES[tipo]?.background || PALETA_COLORES.default.background;
    };

    const getTipoLabel = (tipo) => {
        const labels = { "A": "ACTUALIZACIÓN", "M": "MEJORAS", "N": "NOTICIAS" };
        return labels[tipo] || "NOTICIAS";
    };

    const getBadgeColor = (tipo) => {
        return PALETA_COLORES[tipo]?.badge || PALETA_COLORES.default.badge;
    };

    return (
        <div className="BodyComponent">
            <Breadcrumb>
                <Breadcrumb.Item style={{ fontSize: 14 }}>Inicio</Breadcrumb.Item>
                <Breadcrumb.Item style={{ fontSize: 14 }} active>Novedades</Breadcrumb.Item>
            </Breadcrumb>

            <h4 style={{ fontWeight: 700, marginBottom: 2 }}>NOVEDADES</h4>
            <p style={{ color: "#6c757d", fontSize: 13, marginBottom: 20 }}>
                Mantente al día con las últimas actualizaciones del sistema
            </p>

            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex gap-2">
                    {["Todos", "Actualización", "Mejoras", "Noticias"].map(f => (
                        <Button
                            key={f}
                            size="sm"
                            onClick={() => setFiltro(f)}
                            style={{
                                borderRadius: 20, fontSize: 12, backgroundColor: filtro === f ? "#224B6A" : "white",
                                color: filtro === f ? "white" : "#224B6A",
                            }}
                        >
                            {f}
                        </Button>
                    ))}
                </div>

                <Dropdown>
                    <Dropdown.Toggle variant="outline-secondary" size="sm" style={{ fontSize: 12 }}>
                        {orden}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setOrden("Más reciente")}>Más reciente</Dropdown.Item>
                        <Dropdown.Item onClick={() => setOrden("Más antiguo")}>Más antiguo</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <LoadingComponent Loading={loading} />

            <div>
                {novedadesFiltradas.map((novedad, index) => (
                    <div
                        key={index}
                        className="d-flex align-items-start gap-3 p-3 mb-3"
                        style={{
                            background: "#fff",
                            borderRadius: 8,
                            boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                            borderLeft: `4px solid ${getIconoColor(novedad.tipo)}`
                        }}
                    >
                        <div
                            className="d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                                background: getIconoColor(novedad.tipo)
                            }}
                        >
                            {getIcono(novedad.tipo)}
                        </div>

                        <div className="flex-grow-1">
                            <div className="mb-1">
                                <Badge bg={getBadgeColor(novedad.tipo)} style={{ backgroundColor: getBadgeColor(novedad.tipo), fontSize: 10, fontWeight: 600, letterSpacing: 0.5, color: "#fff" }}>
                                    {getTipoLabel(novedad.tipo)}
                                </Badge>
                            </div>
                            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>{novedad.titulo}</div>
                            <div style={{ color: "#6c757d", fontSize: 13 }} dangerouslySetInnerHTML={{ __html: novedad.texto.substring(0, 60) + "..." }} />
                        </div>

                        <div className="d-flex flex-column align-items-end gap-2 flex-shrink-0">
                            <span style={{ color: "#6c757d", fontSize: 11 }}>{formatDateddMMMyyyy(novedad.fecha)}</span>
                            <Button
                                size="sm"
                                style={{ fontSize: 11, backgroundColor: "#224B6A" }}
                                onClick={() => {
                                    setNovedadSeleccionada(novedad);
                                    setModalDetalles(true);
                                }}
                            >
                                Ver detalles
                            </Button>
                        </div>
                    </div>
                ))}
            </div>

            <Modal show={modalDetalles} onHide={() => setModalDetalles(false)} centered size="lg">
                <Modal.Header style={{ borderBottom: "none", paddingBottom: 0 }}>
                    <div className="d-flex align-items-center gap-2">
                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                background: novedadSeleccionada ? getIconoColor(novedadSeleccionada.tipo) : "#6c757d"
                            }}
                        >
                            {novedadSeleccionada && getIcono(novedadSeleccionada.tipo)}
                        </div>
                        <div>
                            <h6 style={{ marginBottom: 0, fontWeight: 700, fontSize: 14 }}>
                                {novedadSeleccionada?.titulo}
                            </h6>
                            <Badge bg={novedadSeleccionada ? getBadgeColor(novedadSeleccionada.tipo) : "#0d6efd"} style={{ backgroundColor: novedadSeleccionada ? getBadgeColor(novedadSeleccionada.tipo) : "#0d6efd", fontSize: 9, fontWeight: 600, marginTop: 4, color: "#fff" }}>
                                {novedadSeleccionada && getTipoLabel(novedadSeleccionada.tipo)}
                            </Badge>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setModalDetalles(false)}
                        style={{ position: "absolute", right: 16 }}
                    />
                </Modal.Header>

                <Modal.Body style={{ paddingTop: 16 }}>
                    <div style={{ marginBottom: 16 }}>
                        <span style={{ color: "#6c757d", fontSize: 12, fontWeight: 500 }}>
                            Fecha: {novedadSeleccionada && formatDateddMMMyyyy(novedadSeleccionada.fecha)}
                        </span>
                    </div>

                    <div
                        style={{
                            fontSize: 13,
                            color: "#333",
                            lineHeight: 1.6,
                            background: "#f8f9fa",
                            padding: 12,
                            borderRadius: 6,
                            marginBottom: 16
                        }}
                        dangerouslySetInnerHTML={{ __html: novedadSeleccionada?.texto }}
                    />

                    <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid #e9ecef" }}>
                        <p style={{ color: "#6c757d", fontSize: 12, marginBottom: 0 }}>
                            <strong>Tipo de novedad:</strong> {novedadSeleccionada && getTipoLabel(novedadSeleccionada.tipo)}
                        </p>
                    </div>
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "1px solid #e9ecef" }}>
                    <Button variant="danger" size="sm" onClick={() => setModalDetalles(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default NovedadVisualiza;
